export default "__VITE_ASSET__CRWCaEdF__"